var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.426,1.66H4.661c-1.657,0-3,1.343-3,3v14.765c0,1.657,1.343,3,3,3h8.043v-8.095h-2.7v-3.1h2.7v-2.3c-.205-2.066,1.303-3.908,3.37-4.113.213-.021.428-.024.642-.009.806-.012,1.612.03,2.413.124v2.779h-1.669c-1.3,0-1.53.606-1.53,1.516v2h3.075l-.4,3.1h-2.676v8.098h3.497c1.657,0,3-1.343,3-3V4.66c0-1.657-1.343-3-3-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social-facebook.33e0415846a4ce892cda84e48fe38d54.svg";
export { ForwardRef as ReactComponent };